// extracted by mini-css-extract-plugin
export default {"input":"FormulaireYScale_input__gImfp","btnn":"FormulaireYScale_btnn__FuiCy"};